export const CONFIG = {
    version: "1.0.0",
    clientId: "84b5e3d1-9152-4ec7-977c-eb187d0255b3",
    clientKey: "rFOZReUZ5Ld97pSbEbIhRLbzyKs=",
    appId: "1cdc6bf0-b887-11eb-8529-0242ac130003",
    defaultUserRole: 'student'
};